import { createGlobalStyle } from 'styled-components';

/* eslint no-unused-expressions: 0 */
export default createGlobalStyle`
  html {
    -webkit-tap-highlight-color: transparent;
  }

  body {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust:100%;
    -ms-text-size-adjust:100%;
    height: 100%;
    width: 100%;
  }

  .app {
    background-color: #fff;
    min-height: 100%;
    min-width: 100%;
    font-size: 10px;
    font-family: 'Lato', Arial, sans-serif;
    color: #333;

    h1, h2, h3, h4, h5, h6, p {
      margin: 0;
      color: inherit;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }


  :focus {
    outline: none;
  }
  
  ::placeholder { 
    color: rgba(0,0,0,0.6) !important;
  }
`;



// WEBPACK FOOTER //
// ./src/themes/global.js